import { callAPI } from '../../../shared/helpers'

export const ActionTypes = {
  GET_EVENTS: 'GET_EVENTS',
  GET_INITIAL_EVENTS: 'GET_INITIAL_EVENTS',
  CHANGE_PAGE: 'CHANGE_PAGE',
  CHANGE_REGISTRATION_STATUS: 'CHANGE_REGISTRATION_STATUS',
  PUBLISH_LEAGUE: 'PUBLISH_LEAGUE',
}

export const getLeagues = (newPage = 1, searchName = '', sortParam = '', sortOrder = '', resetArray = false) => (dispatch, getState) => {
  const state = getState()
  const url = state.misc.getLeaguesPath
  const params = {}
  params['page'] = newPage
  params['search_name'] = searchName
  params['order_by'] = sortParam
  params['order_type'] = sortOrder

  const actionType = resetArray ? ActionTypes.GET_INITIAL_EVENTS : ActionTypes.GET_EVENTS

  return callAPI(url, 'GET', params)
    .then(data => {
      dispatch({
        type: actionType,
        data: data,
      })
    })
}

export const publishLeague = (id, publishStatus) => (dispatch, getState) => {
  const league = getState().events.events.find(event => event.id === id)
  if (!league) { return }
  return callAPI(league.publishLink, 'POST', { publish_status: publishStatus.toString() }, {}, 'application/json')
    .then((data) => {
      dispatch({
        type: ActionTypes.PUBLISH_LEAGUE,
        data: { id, published: data.golfhub_page_enabled, golfHubLink: data.external_url },
      })
    })
}

export const toggleRegistration = (id, registrationStatus) => (dispatch, getState) => {
  const league = getState().events.events.find(event => event.id === id)
  if (!league) { return }
  callAPI(league.toggleRegistrationLink, 'POST', { registration_is_open: registrationStatus })
    .then(() => {
      dispatch({
        type: ActionTypes.CHANGE_REGISTRATION_STATUS,
        data: { newStatus: registrationStatus, id: id },
      })
    })
}
